import React, { Component } from "react";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { config, msg } from "../../constants";
import {
  fetchOrders,
  deleteOrders,
  toggleDocModal,
  toggleDetailModal
} from "../../store/orders/ordersAction";
import { fetchProjectAddr, fetchAddressDelivery, fetchAddressCompany } from "../../store/project/projectAction";
import { fetchAddress } from "../../store/address/addressAction";
import { fetchCustomer } from "../../store/register/customerAction";
import {
  fetchProvinces,
  fetchDistricts,
  fetchSubDistricts,
  fetchZipCodes
} from "../../store/register/addressAction";
import { toggleAlert } from "../../store/alertbox/alertboxAction";

import ModalConfirm from "./modal";
import { Modal, ModalBody, Spinner } from 'reactstrap';
import DetailModal from "./detail-modal";
import OrderModal from "./order-modal";

import axios from 'axios';

var numeral = require("numeral");
const locale = require("react-redux-i18n").I18n;

class cartPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      detailModal: false,
      orderModal: false,
      orders: [],
      orderDetail: [],
      fetchCustomerFirst: true,
      fetchProjectAddrFirst: true,
      fetchOrdersFirst: true,
      modalIsOpen: false,
      previewModal: false,
      previewUrl: null,
      orders: props.orders,
      orderIdx: null
    }
  }

  // state = {
  //   modal: false,
  //   detailModal: false,
  //   orderModal: false,
  //   orders: [],
  //   orderDetail: [],
  //   fetchCustomerFirst: true,
  //   fetchProjectAddrFirst: true,
  //   fetchOrdersFirst: true,
  //   modalIsOpen: false,
  //   previewModal: false,
  //   previewUrl: null,
  //   orders: props.orders
  // };

  async componentDidMount() {
    let resp = await axios.post(config.apiUrl + "/login/gtkn", {});

    // if (parseInt(resp.data.code) === 200) {
    //   localStorage.setItem('sys_token', resp.data.token);
    // }
    this.openModal()
    this.props.fetchProvinces();
    this.props.fetchDistricts();
    this.props.fetchSubDistricts();
    this.props.fetchZipCodes();
    this.props.fetchAddress();
    // this.closeModal();
  }

  componentWillReceiveProps(next) {
    this.setState({
      orders: next.orders
    });

    if (next.provinces.length !== 0
      && next.districts.length !== 0
      && next.subDistricts.length !== 0
      && next.zipcodes.length !== 0
    ) {
      this.closeModal();
    }

    if (
      this.state.fetchCustomerFirst &&
      next.project.project_id &&
      next.customerID
    ) {
      // console.log('fetchOrders 02');
      this.props.fetchOrders({
        project_id: next.project.project_id,
        customer_id: next.customerID
      });
      this.setState({ fetchOrdersFirst: false });
    }

    if (
      this.state.fetchProjectAddrFirst &&
      next.project.project_id &&
      next.customerID
    ) {
      this.props.fetchProjectAddr({
        customer_id: next.customerID,
        project_id: next.project.project_id,
        address_type: "at003"
      });
      this.props.fetchAddressCompany({
        customer_id: next.customerID,
        project_id: next.project.project_id,
        address_type: "at005"
      });
      this.props.fetchAddressDelivery({
        customer_id: next.customerID,
        project_id: next.project.project_id,
        address_type: "at006"
      });
      this.setState({ fetchProjectAddrFirst: false });
    }

    if (
      this.state.fetchCustomerFirst &&
      next.project.project_id &&
      next.customerID
    ) {
      this.props.fetchCustomer({
        project_id: next.project.project_id,
        customer_id: next.customerID
      });
      this.setState({ fetchCustomerFirst: false });
    }
  }

  updateDocUi = (idx, docItems) => {
    const thisComp = this;
    //document_all
    // console.log('updateDocUi', idx);
    // console.log(docItems);
    let orderItems = thisComp.state.orders;
    orderItems[idx].document_items = docItems;
    // console.log(orderItems);
    this.props.toggleDocModal({});
    thisComp.setState({
      orders: orderItems
    }, () => {
      thisComp.orderModal(thisComp.state.orders[idx], idx);
      alert('เพิ่มเอกสารเสร็จสิ้น');
    });

  };

  modal = () => {
    this.props.toggleAlert(this.props.project.txt_how_to);
  };

  detailModal = order => {
    this.props.toggleDetailModal(order);
  };

  orderModal = (order, idx) => {
    this.setState({
      orderIdx: idx
    });
    this.props.toggleDocModal(order);
  };

  deleteOrders = orderId => {
    this.props.deleteOrders(orderId, this.props.customerID);
  };

  orderStatus(status) {
    if (status === "A") {
      return <span className="status-pass">{locale.t("approve")}</span>;
    } else if (status === "N") {
      return <span className="status-wait">{locale.t("waitconfirm")}</span>;
    } else if (status === "R") {
      return <span className="status-no">{locale.t("reject")}</span>;
    } else if (status === "E") {
      return <span className="status-wait">{locale.t("waitSend")}</span>;
    } else if (status === "S") {
      return <span className="status-wait">{locale.t("send")}</span>;
    } else {
      return <span className="status-wait">{locale.t("waitapprove")}</span>;
    }
  }
  HomePage = () => {
    return config.baseUrl + "/shop/" + this.props.project.project_encrypt;
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  previewFile = async (val) => {
    // console.log(val);
    let resp = await axios.post(config.apiUrl + "/login/gtkn", {});
    const thisComp = this;
    const file_id = val.file_id;
    const file_type = val.file_name.split(".")[1] ? val.file_name.split(".")[1] : "txt";
    var objectURL = `${config.uploadFileUrl}/project/doc/write/${file_type}/${file_id}`;

    thisComp.setState({
      previewUrl: objectURL,
      previewModal: !thisComp.state.previewModal
    }, () => {
      // document.getElementById("idPreviewModal").parentElement.classList.add("modal-full");
    });
  }

  togglePreviewModal = async () => {
    const thisComp = this;
    thisComp.setState({
      previewModal: !thisComp.state.previewModal
    });
  };

  render() {
    const customStyles = {
      textAlign: 'center',
      top: '40%',
    }

    // console.log('in ORDER Rendors ',this.state.orders);

    const orders = this.state.orders.map((orderItem, orderIdx) => {
      let order = orderItem;
      const docSets = (typeof order.doc_structures === 'undefined' || order.doc_structures === null || order.doc_structures === '') ? [] : JSON.parse(order.doc_structures);
      // console.log('----------------------------' + order.order_id + '--------------------------------');
      const documentItems = (typeof order.document_items === 'undefined') ? [] : order.document_items.filter(d => (d.order_id === order.order_id));

      if (typeof order.product_detail === 'undefined') {
        order = {
          ...order, ...{
            product_detail: {
              model_img: '',
              matcode: '',
              model_name: '',
              model_desc: '',
            }
          }
        }
      }

      if (typeof order.order_detail === 'undefined') {
        order = {
          ...order, ...{
            order_detail: {
              address_delivery_type: '',
              msisdn_type: '',
              msisdn_display: '',
            }
          }
        }
      }

      // console.log(order)
      return (
        <tr key={order.order_id}>
          <td data-label="รายการจองสิทธิ">
            <div className="order-dt">
              <div className="row">
                <div className="col-3 col-md-4">
                  <div className="order-img">
                    <img
                      src={order.product_detail.model_img || ''}
                      alt={order.product_detail.matcode || ''}
                    />
                  </div>
                </div>
                <div className="col-9 col-md-8">
                  <div className="order-text">
                    <p className="order-name">
                      {order.product_detail.model_name || ''}
                    </p>
                    <p>{order.product_detail.model_desc || ''}</p>
                  </div>
                </div>
                <div className="col-12 col-md-8 offset-md-4">
                  <div className="order-text">
                    <ul>
                      <li>
                        {locale.t("color")}: <span>{order.product_detail.color || ''}</span>
                      </li>
                      <li>
                        Code: <span>{order.product_detail.matcode || ''}</span>
                      </li>
                      <li>
                        ID: <span>{order.order_id || ''}</span>
                        <div
                          className={
                            order.order_status === "N" || order.order_status === "W" ?
                              this.props.project.order_status === 'A' ?
                                "del-order"
                                :
                                "del-order hide"
                              :
                              "del-order hide"
                          }
                        >
                          <button
                            className="btn btn-light btn-del"
                            onClick={() => this.deleteOrders(order.order_id)}
                          >
                            {locale.t("deleteOrder")}
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td data-label="ราคา/เดือน">
            ฿{numeral(order.price_vat).format("0,0")}
          </td>
          {order.flag_show === 1 ? (
            <td data-label="ราคารวม ทั้งระยะสัญญา">
              ฿{numeral(order.price_total).format("0,0")}
            </td>
          ) : ('')}
          <td data-label="สถานะ">{this.orderStatus(order.order_status)}</td>
          <td data-label="รายละเอียด">
            <div className="dt-list">
              <ul>
                {/* {order.order_detail.address_delivery ? (
                <li className="pass">
                  {order.order_detail.address_delivery_type}
                </li>
              ) : (
                <li>จัดส่งที่อยู่สำนักงานของคุณ</li>
              )} */}
                <li
                  className={
                    order.order_detail.address_delivery_type !== "" ? "pass" : ""
                  }
                >
                  {locale.t("addrDelivery")}:{" "}
                  {order.order_detail.address_delivery_type ? order.order_detail.address_delivery.address_name : '-'}
                </li>

                <li
                  className={
                    order.order_detail.address_delivery_type !== "" ? "pass" : ""
                  }
                >
                  {locale.t("number")}:{" "}
                  {!order.order_detail.msisdn_type && "-"}
                  {order.order_detail.msisdn_type === "new" && "เบอร์ใหม่"}
                  {order.order_detail.msisdn_type === "existing" && order.order_detail.msisdn_display}
                </li>

                <li
                  className={
                    order.order_detail.address_delivery_type !== "" ? "pass" : ""
                  }
                >
                  {locale.t("IRservice")}:{" "}
                  {!order.ir_flag && !order.order_detail.msisdn_type && "-"}
                  {order.ir_flag === 1 && order.order_detail.msisdn_type !== null && "เปิด"}
                  {order.ir_flag !== 1 && order.order_detail.msisdn_type !== null && "ไม่เปิด"}
                </li>

                <li
                  className={
                    order.order_detail.address_bill_type !== "" ? "pass" : ""
                  }
                >
                  {locale.t("addrBill")}:{" "}
                  {/* {!order.ir_flag && !order.order_detail.msisdn_type && "-"}
                  {order.ir_flag === 1 && order.order_detail.msisdn_type !== null && "เปิด"}
                  {order.ir_flag !== 1 && order.order_detail.msisdn_type !== null && "ไม่เปิด"} */}
                  {order.order_detail.address_bill_type ? order.order_detail.address_bill.address_name : '-'}
                </li>
                {/* {order.order_detail.msisdn_type ? (
                <li className="pass">{order.order_detail.msisdn_display}</li>
              ) : (
                <li>เปิดหมายเลขใหม่</li>
              )}
              {order.order_detail.ir_flag ? (
                <li className="pass">เปิดใช้บริการเสริม</li>
              ) : (
                <li>ยังไม่เปิดใช้บริการเสริม</li>
              )} */}
              </ul>
              <button
                // className="btn btn-light btn-edit-dt"
                className="btn btn-light btn-order"
                data-toggle="modal"
                data-target="#edit-dt"
                value={order.order_id}
                onClick={() => {
                  this.detailModal(order);
                }}
                style={((order.address_bill !== null && order.address_bill !== '') ? { backgroundColor: 'green' } : {})}
              >
                {(order.address_bill !== null && order.address_bill !== '') ? 'เปลี่ยนแปลงข้อมูล' : 'กรุณาระบุข้อมูลข้างต้นให้ครบถ้วน'}
              </button>
            </div>
          </td>
          <td data-label="ยืนยันคำสั่งซื้อ">
            <div className="dt-list">
              <ul>
                {/* {order.document_detail.map((doc, index) => (
                  <li className={doc.value ? "pass-check" : ""} key={index}>
                    {" "}
                    {doc.name}{" "}
                  </li>
                ))} */}
                {docSets.map((docItem, index) => {
                  const doc = docItem;
                  // console.log(doc);
                  const docFound = documentItems.filter(d => (d.doc_type_id === doc.id && d.doc_code === doc.code));
                  const theLiStyle = (index === (docSets.length - 1)) ? { paddingTop: '6px', paddingBottom: '6px', textDecoration: 'none', listStyle: 'none' } : { borderBottom: '1px #CCC solid', paddingTop: '6px', paddingBottom: '6px', textDecoration: 'none', listStyle: 'none' };
                  return (docFound.length > 0) ? (
                    <li className="pass-check" key={index} style={theLiStyle}>
                      <a data-toggle="modal" href="#/" onClick={() => {
                        this.previewFile(docFound[0]);
                      }} style={{ fontWeight: 'bold', color: '#447E16' }}>{doc.label}{' '}{(doc.req) ? (<span class="badge rounded-pill bg-danger text-white">Req</span>) : (null)}</a>
                    </li>
                  ) : (
                    <li key={index} style={theLiStyle}>
                      {doc.label}{' '}{(doc.req) ? (<span class="badge rounded-pill bg-danger text-white">Req</span>) : (null)}
                    </li>
                  )
                }
                )}
              </ul>
              <button
                className="btn btn-light btn-order"
                data-toggle="modal"
                data-target="#buy-pd"
                onClick={() => {
                  this.orderModal(order, orderIdx);
                }}
                disabled={
                  order.order_status === "N" || order.order_status === "W" ?
                    order.order_detail.address_delivery_type !== "" ?
                      this.props.project.order_status === 'A' ?
                        false : true
                      : true
                    : true
                }
              >
                {locale.t("confirmOrder")}
              </button>
            </div>
          </td>
        </tr>
      );
    });

    return (
      <>
        <div className="container">
          <h3 className="ttl_page">
            {locale.t("cart")} <i className="la la-shopping-cart" />
          </h3>
          <div className="box-order-main">
            <div className="box-order-main-a">
              <a href={this.HomePage()}>
                <button className="btn btn-cc">
                  {locale.t("backToHome")}{" "}
                </button>
              </a>
              <a
                href="#!"
                className="btn btn-howto"
                data-toggle="modal"
                data-target="#modalalert"
                onClick={this.modal}
              >
                <i className="la la-info" /> {locale.t("howToOrder")}
              </a>
            </div>
            <div className="box-order-main-b">
              <div className="box-list_cart">
                <table className="table_res table_order">
                  <thead>
                    <tr>
                      <th scope="col" width="35%">
                        {locale.t("orderList")}
                      </th>
                      <th scope="col" width="8%">
                        {locale.t("pricePermonth")}
                      </th>
                      {this.state.orders[0] ?
                        this.state.orders[0].flag_show === 1 ?
                          (
                            <th scope="col" width="10%">
                              {locale.t("allPrice")}
                              <br />
                              {locale.t("allContact")}
                            </th>
                          )
                          : ('') : ('')}
                      < th scope="col" width="5%">{locale.t("status")}</th>
                      <th scope="col" width="20%">
                        {locale.t("detail")}
                      </th>
                      <th scope="col">
                        {locale.t("confirmOrder")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>{orders}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <ModalConfirm modal={this.state.modal} text={this.props.project.txt_how_to} />
        <DetailModal
          modal={this.state.detailModal}
          projectData={this.props.project}
          projectAddrData={this.props.projectAddr}
          customerData={this.props.customerProfile}
          provincesData={this.props.provinces}
          districtsData={this.props.districts}
          subDistrictsData={this.props.subDistricts}
          zipcodesData={this.props.zipcodes}
          orderDetailData={this.state.orderDetail}
        />
        <OrderModal modal={this.state.orderModal} idx={this.state.orderIdx} updatedoc={this.updateDocUi} />
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <ModalBody>
            <Spinner color="danger" className={this.state.cssSpinner} />
            {'  ' + msg.register}
          </ModalBody>
        </Modal>

        <Modal
          id="cardPreviewModal"
          isOpen={this.state.previewModal}
          toggle={this.togglePreviewModal}
          dialogClassName="custom-pv-modal"
          bsclassName="pv-modal"
          fullscreen={true}
        >
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
              onClick={this.togglePreviewModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="show-pdf" style={{ minWidth: '100%' }} >
              <embed src={this.state.previewUrl} style={{ minWidth: '100%', minHeight: '800px' }} />
            </div>
          </div>
          <div className="modal-footer" style={{ backgroundColor: "white" }}>
            <button
              type="button"
              className="btn btn-cf btn-sm"
              onClick={this.togglePreviewModal}
            >
              ปิด
            </button>
          </div>
        </Modal>
      </>
    );
  }
}

cartPage.propTypes = {
  fetchOrders: PropTypes.func.isRequired,
  fetchAddress: PropTypes.func.isRequired,
  deleteOrders: PropTypes.func.isRequired,
  toggleDocModal: PropTypes.func.isRequired,
  orders: PropTypes.array.isRequired,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => ({
  orders: state.orders.items,
  isFetching: state.orders.isFetching,
  toggleDocModal: state.orders.toggleDocModal,
  toggleDetailModal: state.orders.toggleDetailModal,
  project: state.project.info,
  projectAddr: state.project.address,
  address_company: state.project.address_company,
  address_delivery: state.project.address_delivery,
  customerProfile: state.customer.data,
  toggleAlert: PropTypes.func.isRequired,
  provinces: state.address.provinces,
  districts: state.address.districts,
  subDistricts: state.address.subDistricts,
  zipcodes: state.address.zipCodes,
  customerID: state.login.customerID,
  user: state.login.info,
  l: state.i18n.locale
});

export default connect(
  mapStateToProps,
  {
    fetchOrders,
    fetchAddress,
    deleteOrders,
    fetchProjectAddr,
    fetchCustomer,
    fetchProvinces,
    fetchDistricts,
    fetchSubDistricts,
    toggleAlert,
    fetchZipCodes,
    toggleDocModal,
    toggleDetailModal,
    fetchAddressDelivery,
    fetchAddressCompany
  }
)(cartPage);
